module.exports = __webpack_public_path__ + "img/live.f129714a.svg";